"use client"

import { createContext, useContext } from "react"

import { IUserInfo } from "../../servers/usercenter/interface"

const UserInfoContext = createContext<{ userInfo: IUserInfo | null; loginStatus: boolean } | undefined>(undefined)

const useUserInfo = () => {
  const context = useContext(UserInfoContext)
  if (!context) {
    throw new Error("useUserInfo must be used within userInfoContext")
  }
  return context
}

export { useUserInfo, UserInfoContext }
